import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Link } from 'react-router-dom';
import styles from '../styles/WeeklyPicks.module.css';

function HomePage() {
  const { user } = useAuth();

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <h1 className={styles.title}>Welcome to LOTW League</h1>

        {!user ? (
          <div className={styles.actionContainer}>
            <p className={styles.subtitle}>Join the competition and make your picks!</p>
            <div className={styles.buttonGroup}>
              <Link to="/login" className={styles.primaryButton}>
                Login
              </Link>
              <Link to="/register" className={styles.secondaryButton}>
                Register
              </Link>
            </div>
          </div>
        ) : (
          <div className={styles.actionContainer}>
            <p className={styles.subtitle}>Ready to make your picks?</p>
            <div className={styles.buttonGroup}>
              <Link to="/weekly-picks" className={styles.primaryButton}>
                Weekly Picks
              </Link>
              <Link to="/leaderboard" className={styles.secondaryButton}>
                View Leaderboard
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default HomePage;
